/**
 * Sophia Platform (Cloudflare Edge-Native Edition)
 *
 * @file        Semantic Theme Toggle Component for Admin Portal (Task 11.1.3)
 * @author      Le Viet Quang <quangle@fourelementscorp.com>
 * @copyright   (c) 2026 Le Viet Quang / Four Elements Corp
 * @license     MIT
 */

import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeProvider';

export const ThemeToggle: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { isDark, setThemeMode } = useTheme();

  return (
    <button
      type="button"
      onClick={() => setThemeMode(isDark ? 'light' : 'dark')}
      className={`p-2 rounded-lg border border-surface-border bg-surface text-foreground hover:bg-surface-elevated transition-colors focus:outline-none focus:ring-2 focus:ring-primary/40 ${className}`}
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      aria-label="Toggle Theme"
    >
      {isDark ? (
        <Sun className="w-4 h-4 text-amber-400 hover:text-amber-300 transition-colors" />
      ) : (
        <Moon className="w-4 h-4 text-slate-700 hover:text-slate-900 transition-colors" />
      )}
    </button>
  );
};
